$(document).on('click', '[data-search-toggle]', function(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  const target = $(this).attr('data-search-toggle');
  const search = $(document).find(`#${target}`);
  search.addClass('is-open');
  search.find('input[name="q"]').val('').focus();
});

$(document).on('click', 'body', (event) => {
  const inSearch = $(event.target).closest('[data-search-container]').length !== 0;
  if (!inSearch) {
    const search = $('[data-search-container].is-open');
    if (search) {
      search.removeClass('is-open');
    }
  }
});
